import React, { useState, useEffect, useRef } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import styles from 'styles';

const HtmlContent = React.memo((props) => {
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [letter, setLetter] = useState(props.letter);
    const iframeRef = useRef(null);

    const toggleDialog = () => {
        setIsOpenDialog(!isOpenDialog);
    };
    useEffect(() => {
        setLetter(props.letter);
    }, [props.letter]);

    const actions = [
        <FlatButton
            label='CLOSE'
            primary
            onClick={toggleDialog}
        />,
    ];

    return (
        <div className="btn">
            <RaisedButton
                onClick={toggleDialog}
                disabled={!letter.html}
                label='HTML'
                labelStyle={{ fontSize: '10px' }}
                style={{ height: '25px', minWidth: '50px' }}
                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                primary
            />
            <Dialog
                title='HTML'
                actions={actions}
                modal={false}
                contentStyle={styles.Dialog}
                open={isOpenDialog}
                onRequestClose={toggleDialog}
            >
                <iframe
                    srcDoc={letter.html}
                    sandbox=""
                    title='html_iframe'
                    style={{
                        overflow: 'auto', border: 'none', width: '100%', height: '65vh', 
                    }}
                    ref={iframeRef}
                    frameBorder="0"
                />
            </Dialog>
        </div>
    );
});

export default HtmlContent;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/HtmlContent.jsx